export default defineNuxtPlugin({
	name: 'cms-preview-idle-guard',
	enforce: 'pre',
	setup() {
		const enabled = useRuntimeConfig().public.cmsEditorPreviewEnabled;
		if ((enabled !== true && enabled !== 'true') || window.parent === window) return;
		const query = new URLSearchParams(window.location.search);
		if (!['version_id', 'preview_expires', 'preview_token', 'preview_editor_origin'].every(key => String(query.get(key) || '').trim())) return;
		updateAppConfig({idleReloadTimeout: 0});
	},
});
